import {INIT_BOOKING_CONTEXT} from "../data";
import {AppError, Availability} from '@/shared/models';

export const actions = {
    initContext({commit, getters}, avail){
        if(!avail){
            throw new AppError('No avail');
        }
        if(!avail.startTime || !avail.endTime || avail.startTime >= avail.endTime){
            throw new AppError('start date and end date must be defined and start date < end date');
        }
        commit('setAvail', avail);
        commit('setContext', INIT_BOOKING_CONTEXT);
    }/*,
    async book({commit, getters}, bookingContext){
        bookingContext.availabilityCar.availability = getters.avail;
        const result = await LocationsApi.book(bookingContext);
        bookingContext.number = result.number;
        commit('setContext', bookingContext);
        return bookingContext;
    }*/
};